const root = {
    LOGIN: "login."
};

const EventBusEvents = {
    ERROR_CODE: root.LOGIN + "error_code",
    VERIFICATION_ERROR_CODE: root.LOGIN + "verify_error_code",
    FORGOT_USERNAME_PASSWORD: "forgot_username_password_clicked",
    HERO_BANNER_CLICKED: "hero_banner_clicked",
    PRELOGIN_BANNER_LOWER_TILES_CLICKED: "prelogin_banner_lower_tiles_clicked",
    ONETRUST_ACCEPT_COOKIES: "OneTrust_accept_cookies_button_clicked",
    ONETRUST_DO_NOT_SELL_SHARE_INFO:
        "OneTrust_do_not_sell_or_share_my_personal_information_link_clicked",
    ONETRUST_CLOSE_PROMPT_CLICKED: "OneTrust_X_to_close_prompt_clicked"
};

export default EventBusEvents;
